import { mergeStyles, MessageBar, MessageBarType, Spinner, SpinnerSize, Stack, Text } from '@fluentui/react';
import { useEffect, useState } from 'react';

import { useAppSelector } from '../../App/store';
import Cell from './Cell';
import getDailyItems from './getDailyItems';

export default () => {
  const isLoading = useAppSelector((state) => state.calendar.loading);
  const dailyItems = getDailyItems();

  if (isLoading) {
    return (
      <Spinner
        size={SpinnerSize.large}
        className={spinnerStyles}
        label="Bilgi Alınıyor"
      />
    );
  }

  return (
    <MessageBar messageBarType={MessageBarType.severeWarning}>
      Geçici olarak devre dışı.
    </MessageBar>
  );

  return (
    <Stack tokens={{ childrenGap: 15 }} className={rootStyles}>
      <Text variant="xxLarge">Takvim</Text>
      <Stack wrap horizontal>
        {dailyItems.map((dayInfo, i) => (
          <Cell
            key={dayInfo.date.getTime()}
            date={dayInfo.date}
            items={dayInfo.items}
          />
        ))}
      </Stack>
    </Stack>
  );
};

const rootStyles = mergeStyles({
  width: "90%",
  marginLeft: "5%",
  marginTop: "16px",
});
const spinnerStyles = mergeStyles({
  marginTop: "50px",
});
